import { required } from 'vuelidate/lib/validators'
import validatorsByFields from '@/utils/validations/validatorsByFields'
const units = validatorsByFields.dimensions
const requiredMsg = 'Обязательное поле'
export default vars => {
  return {
    title: {
      required: {
        validator: required,
        message: requiredMsg
      }
    },
    slotId: {
      required: {
        validator: required,
        message: requiredMsg
      }
    },
    height: {
      required: {
        validator: required,
        message: requiredMsg
      },
      ...units
    },
    width: {
      required: {
        validator: required,
        message: requiredMsg
      },
      ...units
    },
    url: {
      required: {
        validator: required,
        message: requiredMsg
      }
    }
  }
}
